export function crmPopup() {
    function getCookie(name) {
      const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
  
    function setCookie(name, value, options = {}) {
      options = { path: '/', ...options };
      let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += "=" + optionValue;
        }
      }
      document.cookie = updatedCookie;
    }
  
    if (!_farlo.storage.get("mastheadLightboxShown","session")) {
      setTimeout(function () {
        // Only auto-open when "Show Popup on Load" is enabled on the page
        const onloadButton = document.querySelector('.farlo-ui-crm__popup-onload .farlo-ui-crm__toggle');
        const lightboxForm = onloadButton
          ? document.getElementById(onloadButton.dataset.crmButtonFor)
          : null;

        if (lightboxForm) {
          const crmId = lightboxForm.getAttribute('data-crm-id') || lightboxForm.id;
          const toggleButton = document.querySelector(`.farlo-ui-crm__toggle[data-crm-button-for="${crmId}"]`);
          if (toggleButton) {
            toggleButton.click();
          } else if (typeof farloUiCrmSignup === "function") {
            farloUiCrmSignup(crmId);
          }
        }

        if (document.querySelector('.crm-lightbox') && document.querySelector('.crm-lightbox').scrollHeight) {
          document.documentElement.style.setProperty('--crm-lightbox-height', (document.querySelector('.farlo-ui-crm__form-container').scrollHeight + 20) )
        }
      }, 1000);
    }
  
  }